import trackingProduct from './trackingProduct'
import trackingUser from './trackingUser'

export default {
  modules: {
    trackingUser,
    trackingProduct,
  }
}
